/* ============================================================
   BRIGHTBOX LIGHTING — Main JavaScript
   Handles: Header scroll, Hero slider, Cart drawer,
            Mobile nav, Search overlay, Animations
   ============================================================ */

(function () {
  'use strict';

  /* ── HEADER SCROLL ── */
  const header = document.getElementById('bb-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── HERO SLIDER ── */
  const heroSlides = document.querySelectorAll('.bb-hero__slide');
  const heroDots   = document.querySelectorAll('.bb-hero__dot');
  let heroIdx      = 0;
  let heroTimer    = null;

  function goToSlide(idx) {
    heroSlides[heroIdx].classList.remove('active');
    heroDots[heroIdx] && heroDots[heroIdx].classList.remove('active');
    heroDots[heroIdx] && heroDots[heroIdx].setAttribute('aria-selected', 'false');
    heroIdx = (idx + heroSlides.length) % heroSlides.length;
    heroSlides[heroIdx].classList.add('active');
    heroDots[heroIdx] && heroDots[heroIdx].classList.add('active');
    heroDots[heroIdx] && heroDots[heroIdx].setAttribute('aria-selected', 'true');
  }

  function startHeroTimer() {
    const speed = parseInt(
      document.querySelector('.bb-hero-section')?.dataset?.autoplaySpeed || '6'
    ) * 1000;
    heroTimer = setInterval(() => goToSlide(heroIdx + 1), speed);
  }

  if (heroSlides.length > 1) {
    heroDots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        clearInterval(heroTimer);
        goToSlide(i);
        startHeroTimer();
      });
    });
    startHeroTimer();

    // Touch/swipe support
    let touchStartX = 0;
    const hero = document.getElementById('bb-hero');
    if (hero) {
      hero.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', e => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          clearInterval(heroTimer);
          goToSlide(diff > 0 ? heroIdx + 1 : heroIdx - 1);
          startHeroTimer();
        }
      });
    }
  }

  /* ── MOBILE NAV ── */
  const hamburger   = document.getElementById('bb-hamburger');
  const mobileNav   = document.getElementById('bb-mobile-nav');
  const mobileClose = document.getElementById('bb-mobile-nav-close');
  const overlay     = document.getElementById('bb-overlay');

  function openMobileNav() {
    hamburger?.classList.add('open');
    hamburger?.setAttribute('aria-expanded', 'true');
    mobileNav?.classList.add('open');
    mobileNav?.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('visible');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    hamburger?.classList.remove('open');
    hamburger?.setAttribute('aria-expanded', 'false');
    mobileNav?.classList.remove('open');
    mobileNav?.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('visible');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', () => {
    hamburger.classList.contains('open') ? closeMobileNav() : openMobileNav();
  });
  mobileClose?.addEventListener('click', closeMobileNav);

  /* ── MOBILE NAV ACCORDIONS ── */
  document.querySelectorAll('.bb-mobile-nav__group-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const sub    = toggle.nextElementSibling;
      const isOpen = toggle.classList.contains('open');
      // Close all open accordions first
      document.querySelectorAll('.bb-mobile-nav__group-toggle.open').forEach(t => {
        t.classList.remove('open');
        t.setAttribute('aria-expanded', 'false');
        t.nextElementSibling?.classList.remove('open');
      });
      // Open the clicked one if it was closed
      if (!isOpen) {
        toggle.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
        sub?.classList.add('open');
      }
    });
  });

  /* ── SEARCH OVERLAY ── */
  const searchToggle  = document.getElementById('bb-search-toggle');
  const searchOverlay = document.getElementById('bb-search-overlay');
  const searchClose   = document.getElementById('bb-search-close');
  const searchInput   = document.getElementById('bb-search-input');

  function openSearch() {
    searchOverlay?.classList.add('open');
    searchOverlay?.setAttribute('aria-hidden', 'false');
    setTimeout(() => searchInput?.focus(), 100);
    document.body.style.overflow = 'hidden';
  }

  function closeSearch() {
    searchOverlay?.classList.remove('open');
    searchOverlay?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  searchToggle?.addEventListener('click', openSearch);
  searchClose?.addEventListener('click', closeSearch);
  searchOverlay?.addEventListener('click', e => {
    if (e.target === searchOverlay) closeSearch();
  });

  /* ── OVERLAY CLICK ── */
  overlay?.addEventListener('click', () => {
    closeMobileNav();
    closeCart();
  });

  /* ── ESCAPE KEY ── */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeCart();
      closeSearch();
    }
  });

  /* ── CART DRAWER ── */
  const cartDrawer  = document.getElementById('bb-cart-drawer');
  const cartToggle  = document.getElementById('bb-cart-toggle');
  const cartClose   = document.getElementById('bb-cart-close');
  const cartCount   = document.getElementById('bb-cart-count');
  const cartItems   = document.getElementById('bb-cart-items');
  const cartEmpty   = document.getElementById('bb-cart-empty');
  const cartFooter  = document.getElementById('bb-cart-footer');
  const cartSubtotal = document.getElementById('bb-cart-subtotal');
  const progressFill = document.getElementById('bb-progress-fill');
  const progressAmount = document.getElementById('bb-progress-amount');

  const FREE_DELIVERY_THRESHOLD = 15000; // £150 in pence

  function openCart() {
    cartDrawer?.classList.add('open');
    overlay?.classList.add('visible');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    cartDrawer?.classList.remove('open');
    overlay?.classList.remove('visible');
    document.body.style.overflow = '';
  }

  cartToggle?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    if (!cartCount) return;
    cartCount.textContent = count;
    cartCount.classList.toggle('visible', count > 0);
  }

  function updateProgress(total) {
    if (!progressFill || !progressAmount) return;
    const pct = Math.min(100, (total / FREE_DELIVERY_THRESHOLD) * 100);
    progressFill.style.width = pct + '%';
    if (total >= FREE_DELIVERY_THRESHOLD) {
      document.getElementById('bb-progress-text').innerHTML = '🎉 You qualify for <strong>free delivery!</strong>';
    } else {
      const remaining = formatMoney(FREE_DELIVERY_THRESHOLD - total);
      document.getElementById('bb-progress-text').innerHTML =
        'Add <strong id="bb-progress-amount">' + remaining + '</strong> more for free delivery';
    }
  }

  function renderCartItems(cart) {
    if (!cartItems) return;

    if (cart.item_count === 0) {
      cartEmpty && (cartEmpty.style.display = 'block');
      cartFooter && (cartFooter.style.display = 'none');
      cartItems.innerHTML = '';
      cartItems.appendChild(cartEmpty);
      return;
    }

    cartEmpty && (cartEmpty.style.display = 'none');
    cartFooter && (cartFooter.style.display = 'block');

    const html = cart.items.map(item => `
      <div class="bb-cart-item" data-key="${item.key}">
        <img class="bb-cart-item__img"
          src="${item.image || ''}"
          alt="${item.title}"
          loading="lazy">
        <div>
          <p class="bb-cart-item__title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="bb-cart-item__variant">${item.variant_title}</p>` : ''}
          <div class="bb-cart-item__footer">
            <div class="bb-cart-item__qty">
              <button onclick="bbUpdateCartItem('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button onclick="bbUpdateCartItem('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
            </div>
            <span class="bb-cart-item__price">${formatMoney(item.line_price)}</span>
          </div>
        </div>
      </div>
    `).join('');

    cartItems.innerHTML = html;
    if (cartEmpty) cartItems.appendChild(cartEmpty);
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        updateProgress(cart.total_price);
        renderCartItems(cart);
        if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
      })
      .catch(err => console.error('[Brightbox Cart]', err));
  }

  // Expose for product form
  window.bbUpdateCartItem = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        updateProgress(cart.total_price);
        renderCartItems(cart);
        if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
      });
  };

  // Intercept add-to-cart forms
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.matches('#bb-product-form')) return;
    e.preventDefault();

    const btn = form.querySelector('[name="add"]');
    const originalText = btn?.textContent;
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    const data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
      .then(r => r.json())
      .then(() => {
        fetchCart();
        openCart();
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      })
      .catch(err => {
        console.error('[Brightbox Add to Cart]', err);
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      });
  });

  // Quick-add buttons (product cards)
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.matches('.bb-product-card__quick-add form')) return;
    e.preventDefault();

    const data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
      .then(r => r.json())
      .then(() => {
        fetchCart();
        openCart();
      });
  });

  /* ── SCROLL ANIMATIONS ── */
  const fadeEls = document.querySelectorAll('.bb-fade-up');
  if ('IntersectionObserver' in window && fadeEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(el => observer.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('visible'));
  }

  /* ── COLLECTION GRID TOGGLE ── */
  const gridToggles = document.querySelectorAll('.bb-grid-toggle');
  const productsGrid = document.getElementById('bb-products-grid');
  gridToggles.forEach(btn => {
    btn.addEventListener('click', () => {
      gridToggles.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (productsGrid) {
        const cols = btn.dataset.cols;
        productsGrid.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;
      }
    });
  });

  /* ── COLLECTION SORT ── */
  const sortSelect = document.getElementById('bb-sort');
  if (sortSelect) {
    // Set current sort from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) sortSelect.value = currentSort;

    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ── INIT CART COUNT ── */
  fetchCart();

})();
